<template>
  <v-text-field
    :label="i18n(label)"
    :outlined="outlined"
    :readonly="readonly"
    :autofocus="autofocus"
    :prepend-inner-icon="icon"
    :hide-details="hideDetails"
    x-small
    v-model="str"
  />
</template>

<script>

export default {
  props: {
    icon: {},
    value: {},
    label: { default: 'field.str' },
    outlined: { default: false },
    readonly: { default: false },
    autofocus: {},
    hideDetails: { default: true }
  },

  data () {
    let str = String(this.value || '').trim()
    if (!str) str = null
    return { str }
  },

  watch: {
    str () {
      let str = String(this.str || '').trim()
      if (!str) str = null

      let value = String(this.value || '').trim()
      if (!value) value = null

      str !== value && this.$emit('input', str)
    },

    value () {
      let str = String(this.str || '').trim()
      if (!str) str = null

      let value = String(this.value || '').trim()
      if (!value) value = null

      const changed = str !== value
      if (changed) this.str = value
    }
  }
}
</script>
